import React from "react";
import classNames from "classnames";
import styles from "./radio-button.module.scss";

const RadioButton = ({
  text,
  value = "",
  radioGroup = "",
  onClick,
  isLoading = false,
  disabled = false,
  checked = false,
  inputRef = undefined,
  className = ""
}) => (
  <label
    className={classNames(styles["radio-btn"], className, {
      [styles["radio-btn__disabled"]]: disabled,
      [styles["radio-btn--is-loading"]]: isLoading
    })}
  >
    <input
      type="radio"
      className={styles["radio-btn__radio"]}
      value={value || text}
      name={radioGroup || "radio-button-group"} // ensures only one radio per group can be selected
      onChange={!isLoading ? onClick : undefined}
      disabled={disabled}
      checked={!isLoading ? checked : undefined}
      ref={inputRef}
    />
    <span className={styles["radio-btn__label"]}>{text}</span>
  </label>
);

export default RadioButton;
